import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: 'dhl-select-input',
    templateUrl: './simple-select-input.component.html',
    styleUrls: ['./simple-select-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DHLSimpleSelect implements OnInit {
  @Input() label: string;
  @Input() defaultValue: string;
  @Output() selectionChanged = new EventEmitter<string>();
  @Input() configData;
  options:any

  public noteSelectTypes: any[] = [];
  public FilterednoteSelectTypes: any[] = [];
  private userRole = localStorage.getItem('userRole');
  
  ngOnInit(): void {
   
    this.noteSelectTypes = this.configData.noteSelectTypes;
    this.FilterednoteSelectTypes = this.configData.noteSelectTypes.filter(o => o.roleAccess?.includes(this.userRole));
    this.options = this.noteSelectTypes

    if (!this.defaultValue) {
      if (this.options.length) {
        this.defaultValue = this.options[0].value;
      }
    }
    this.initializeArrayOne();
  }

  initializeArrayOne() {
    if (!this.areArraysEqual(this.noteSelectTypes, this.FilterednoteSelectTypes)) {
      this.noteSelectTypes = this.noteSelectTypes.map(item => ({
        ...item,
        disabled: this.FilterednoteSelectTypes.some(disabledItem => disabledItem.label === item.label)
      }));
    }
  }

  areArraysEqual(array1: any[], array2: any[]): boolean {
    return array1.length === array2.length && array1.every((item, index) => item.label === array2[index].label);
  }

  isDisabled(item: any): boolean {
    return !this.FilterednoteSelectTypes.some(disabledItem => disabledItem.label === item.label);
  }

  onChange(v: string) {
    this.selectionChanged.emit(v)
  }
}